import { Link } from "react-router-dom";
import { MEDIA, TAGLINE } from "@/lib/media";

const COLS = [
  { title: "Give", links: [["Donate Money", "/donate"], ["In-Kind Wish List", "/wishlist"], ["Drop-Off", "/drop-off"], ["Sponsor", "/sponsors"]] },
  { title: "Programs", links: [["Service Dogs", "/service-dog-program"], ["Master Trainers", "/trainer-program"], ["Volunteer", "/volunteer"], ["14DDV Event", "/14ddv"]] },
  { title: "Foundation", links: [["About", "/about"], ["Golden Founder", "/golden-founder"], ["Mission", "/mission"], ["Artist Gallery", "/artists"]] },
  { title: "Trust", links: [["Financial Transparency", "/financial-transparency"], ["Privacy Policy", "/privacy"], ["Terms", "/terms"], ["Accessibility", "/accessibility"]] },
];

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-6 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={MEDIA.logo} alt="Golden Wolf Foundation" className="h-14 w-14 object-contain" />
            <div className="font-heading text-xl font-bold">Golden Wolf</div>
          </div>
          <p className="text-[#8A877B] text-sm max-w-xs leading-relaxed">{TAGLINE}</p>
          <p className="text-[#8A877B] text-xs mt-4">Chicago, IL · GoldenWolfVets.org</p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <div className="overline mb-4">{c.title}</div>
            <ul className="space-y-2">
              {c.links.map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="text-sm text-[#C8C4B7] hover:text-[#D4AF37] transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-[#8A877B]">
        © {new Date().getFullYear()} Golden Wolf Foundation. A nonprofit organization. ·{" "}
        <Link to="/admin" className="hover:text-[#D4AF37]" data-testid="footer-admin-link">Staff Login</Link>
      </div>
    </footer>
  );
}
